export default "__VITE_ASSET__DDa0dlld__"